import { isRouteErrorResponse } from "react-router";

import { SUPPORT_EMAIL } from "#app/lib/constants.ts";

import { Html, type HtmlProps } from "./html.tsx";
import { Button } from "./ui/button.tsx";
import { MinimalLayout } from "./layout/minimal.tsx";

export function NotFoundPage(props: HtmlProps) {
  return (
    <Html {...props} title="Page Not Found | Palmetto Homeschool Association">
      <MinimalLayout title="Page Not Found">
        <div className="flex flex-col items-center space-y-4">
          <p>The page you were looking for could not be found.</p>

          <Button asChild>
            <a href="/">Back to Home</a>
          </Button>
        </div>
      </MinimalLayout>
    </Html>
  );
}

export function UnknownErrorPage({
  error,
  ...htmlProps
}: { error: unknown } & HtmlProps) {
  let title = "An Unknown Error Occurred";
  if (isRouteErrorResponse(error)) {
    title = `Error ${error.status}${error.statusText ? `: ${error.statusText}` : ""}`;
  } else if (error instanceof Error) {
    title = error.message;
  }

  return (
    <Html
      {...htmlProps}
      title="An Error Occurred | Palmetto Homeschool Association"
    >
      <MinimalLayout title={title}>
        <div className="flex flex-col items-center space-y-4 text-center">
          <p>An error occurred while trying to load this page.</p>
          <p>
            We've automatically been notified of this error, but if you continue
            to see this issue after several hours, please send an email to{" "}
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="text-primary underline"
            >
              {SUPPORT_EMAIL}
            </a>
            .
          </p>

          <Button asChild>
            <a href="/">Back to Home</a>
          </Button>
        </div>
      </MinimalLayout>
    </Html>
  );
}
